var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-gray p-2" }, [
    _c("div", { staticClass: "bg-white p-3" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _c("div", { staticClass: "col-12 col-md-5" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Estudiante: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(
              " " +
                _vm._s(_vm.value.studentSieId) +
                " - " +
                _vm._s(_vm.value.studentFullName) +
                " "
            )
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-3" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Tipo de Servicio: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.value.discipline) + " ")
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-3" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Proveedor: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.value.provider) + " ")
          ])
        ]),
        _c("div", { staticClass: "col-12" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Comentario: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.value.comment) + " ")
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-info-circle text-orange mr-1" }),
      _c("span", [_vm._v("Información Adicional")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }